// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header_119Q8","title":"style_title_2S9FQ","right":"style_right_l2bJL","default":"style_default_2WDz2"};